import { filter, map } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { roomTypes } from '../../../actions/room/roomTypes'
import { syncUiType } from '../../../actions/docs/syncUi/syncUiTypes'
import { ReduxAction, State } from '../../../reducers/reducerType'
import uiFunctions from '../../../actions/ui/uiFunctions'

/** If a dialed-in presenter joins and autoSpotlight is on */
export const notifyPresenterWhenDialledInParticipantAndAutoSpotlight$ = (action$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => action$.pipe(
  ofType<ReduxAction <roomTypes | syncUiType>>(roomTypes.SET_DIALED_IN_PRESENTER,
    syncUiType.SET_SYNC_AUTO_SPOTLIGHT,
    syncUiType.SET_SYNC_CHECK_DIAL_IN_NOTIFICATION
  ),
  filter(() => state$.value.room.dialedInParticipants.length > 0 &&
    state$.value.syncUi.autoSpotlight),
  map(() => uiFunctions.showSpotlightNotification())
)

export default notifyPresenterWhenDialledInParticipantAndAutoSpotlight$
